import { NotificationService } from '../notification/swal/notification.service';
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import Auth from '../helpers/auth';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private notificationService: NotificationService, private router: Router) { }

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (Auth.userIsAuthenticated()) {
      return true;
    } else {
      this.notificationService.showAlertNotification('Sua sessão expirou!', { allowOutsideClick: false, showCancelButton: false })
        .then(() => {
          localStorage.clear();
          this.router.navigate(['/login']);
        });
      return false;
    }
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/guards/auth.guard.ts